import {SearchApi} from "../../search/services/search.api";

export class RelatedEntitiesApi extends SearchApi {
}
